import React, {useMemo} from 'react'
import styled from 'styled-components'
import {Autocomplete, TextField} from '@mui/material'
import {useLanguage} from 'store/Store.js'
import {getPhoneCountries} from 'logic/Profile/phoneCountries.js'

// country code drop-down + the number without the country code, see joinPhone
const PhoneInput = ({
    country,
    number,
    onCountryChange,
    onNumberChange,
    countryLabel,
    numberLabel,
    error,
    helperText,
    name = 'phone',
}) => {
    const language = useLanguage()
    const phoneCountries = useMemo(
        () => getPhoneCountries(language),
        [language]
    )

    return (
        <PhoneContainer>
            <CountryAutocomplete
                disableClearable
                options={phoneCountries}
                value={phoneCountries.find(
                    (option) => option.country === country
                )}
                onChange={(event, option) => onCountryChange(option.country)}
                isOptionEqualToValue={(option, value) =>
                    option.country === value.country
                }
                getOptionLabel={({flag, name: countryName, callingCode}) =>
                    `${flag} ${countryName} ${callingCode}`
                }
                renderOption={(
                    props,
                    {
                        country: optionCountry,
                        flag,
                        name: countryName,
                        callingCode,
                    }
                ) => (
                    <li {...props} key={optionCountry}>
                        {flag} {countryName}&nbsp;<bdi>{callingCode}</bdi>
                    </li>
                )}
                renderInput={(params) => (
                    <TextField {...params} label={countryLabel} />
                )}
            />
            <PhoneTextField
                id={name}
                type="tel"
                label={numberLabel}
                name={name}
                autoComplete="tel-national"
                placeholder="0542111079"
                value={number}
                error={error}
                helperText={helperText}
                inputProps={{dir: 'ltr'}}
                onChange={onNumberChange}
            />
        </PhoneContainer>
    )
}

export default PhoneInput

const PhoneContainer = styled.div`
    display: flex;
    gap: 10px;
    width: 450px;

    @media (max-width: 600px) {
        flex-direction: column;
        width: 250px;
    }
`

const CountryAutocomplete = styled(Autocomplete)`
    && {
        flex: 1;
    }
`

const PhoneTextField = styled(TextField)`
    && {
        flex: 1;
    }
`
